import { Form, Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AggregationTypes } from '../../types/Formula'

const FormulaAggregationTypeField: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Form.Item initialValue={AggregationTypes.sum} name="aggregationType" label={t('formulaPage:aggregationType')}>
      <Select showSearch optionFilterProp="children" style={{ width: 300 }}>
        {Object.keys(AggregationTypes).map(aggregationType => (
          <Select.Option key={aggregationType} value={aggregationType}>
            {t(`formulaPage:${aggregationType}`)}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default FormulaAggregationTypeField
